@let user = user$ | async;
@let userRoles = userRoles$ | async;

@if (user) {
  <div class="userSection">
    <app-side-bar-menu
      [userRoles]="userRoles!"
      [userInfo]="user"
      [hidden]="!isSideBarMenuOpened"
      (closeSideBarMenu)="closeSideBarMenu()"></app-side-bar-menu>
    <button class="userInfoBlock" (click)="toggleSideBarMenuOpen()">
      @if (user.company.companyStatus === companyStatusBlocked) {
        <span class="userInfoBlock--blocked">!</span>
      }

      <img
        [src]="user.logoUrl || 'assets/svg/user-plug.svg'"
        width="40px"
        height="40px"
        alt="userPicture" />
    </button>
  </div>
}
